type Props = {
  stockLabel?: string
  availableStock: number
  valuationPerUnit?: number
}

export const InventoryStateSummary: React.FC<Props> = ({
  stockLabel = 'Available Stock',
  availableStock,
  valuationPerUnit,
}) => {
  return (
    <div className='row mb-6'>
      <label className='col-lg-2 col-form-label fw-bold fs-6'>{stockLabel}</label>
      <div className='col-lg-4 fv-row'>
        <input
          type='text'
          className='form-control form-control-lg'
          style={{
            backgroundColor: '#FFF5F8',
            color: '#F1416C',
            border: '1px dashed #F1416C',
            borderRadius: '6px',
          }}
          readOnly
          value={availableStock}
        />
      </div>

      {valuationPerUnit !== undefined && (
        <>
          <label className='col-lg-2 col-form-label fw-bold fs-6'>FIFO Rate / Unit</label>
          <div className='col-lg-4 fv-row'>
            <input
              type='text'
              className='form-control form-control-lg'
              style={{
                backgroundColor: '#EEF6FF',
                color: '#0d6efd',
                border: '1px dashed #0d6efd',
                borderRadius: '6px',
              }}
              readOnly
              value={valuationPerUnit.toFixed(2)}
            />
          </div>
        </>
      )}
    </div>
  )
}
